import React, { useEffect, useState } from "react";
import DagBoekList from "./detail/DagBoekList";
import { getUser, getUserdetails } from "../../Localstorage/localstorage";
import Swal from "sweetalert2";
import { AXIOS_POST, AXIOS_UPDATE } from "../../server/api/crud";
import ReInput from "../../Componenten/Layout/ReInput";
import TypeNote from "./TypeNote";
import { DocumentIcon, PaperClipIcon } from "@heroicons/react/24/solid";
import Select2 from "../../Componenten/Select2";
import RPDrawerComment from "../../Componenten/Drawers/RPDrawerComment";
import { useSelector } from "react-redux";
import SelectPatienten from "../../Componenten/SelectPatienten";
import moment from "moment";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

const EetdagboekAdmin = ({}) => {
  const { patienten } = useSelector((state) => state.user);
  const [dagboeken, setDagboeken] = useState([]);
  const user = getUser();
  const userdetails = getUserdetails();
  const [command, setCommand] = useState("insert");
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(patienten[0]);
  const [showEdit, setShowEdit] = useState(true);

  const [dates, setdates] = useState({
    startdate: moment().startOf('month').format('YYYY-MM-DD'),
    enddate: moment().endOf('month').format('YYYY-MM-DD'),
  });

  const eetdagboek = {
    user_id: user?.id,
    datum: new Date(),
    dag: "",
    ochtend: "",
    voormiddag: "",
    middag: "",
    namiddag: "",
    avond: "",
    smorgens: "",
    smiddags: "",
    savonds: "",
    type_note: 1,
    title: "",
    admin: userdetails?.full_name || user?.username,
    admin_id: userdetails?.user_id || user?.id,
    score: 0,
    opmerking: "",
  };

  let commentaaradmin = {
    admin: userdetails?.full_name || user?.username,
    admin_id: userdetails?.user_id || user?.id,
    score: 0,
    opmerking: "",
  };

  const [updateAdmin, setUpdateAdmin] = useState(commentaaradmin);
  const [formData, setFormData] = useState(eetdagboek);

  useEffect(() => {
    const fetchDaymealData = async (search) => {
      let adminUpdate = {};
      try {
        const response = await AXIOS_POST(`eetdagboek/user`, search);
        let eetdagboeken = response.data.data;

        setDagboeken(eetdagboeken);
        setRefresh(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    let newId = selected?.user_id || patienten[0]?.user_id;
    const search = {
      id: newId,
      startdate: moment(dates?.startdate).format('YYYY-MM-DD'),
      enddate: moment(dates?.enddate).format('YYYY-MM-DD'),
    };
    if (selected || patienten?.length > 0 || formData || dates) {
      fetchDaymealData(search);
    }
  }, [open, patienten, formData, selected, dates?.startdate, dates?.enddate]);

  /* useEffect(() => {
    if (selected)
      setdates({
        ...dates,
        startdate: moment(selected?.created_at).format("YYYY-MM-DD"),
      });
  }, [selected]); */

  const validateForm = () => {
    if (!formData?.score) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title:
          "De gegevens zijn niet opgeslagen. Gelieve een score in te voeren. Deze wordt meegerekend bij de vooruitgang van de klant.",
        showConfirmButton: false,
        timer: 2500,
      });
      return false;
    }

    return true;
  };

  const Opslaan = async () => {
    if (!validateForm()) return;
    const newObject = {
      admin: formData.admin,
      admin_id: formData.admin_id,
      score: formData.score,
      opmerking: formData.opmerking,
    };
    try {
      await AXIOS_UPDATE(`eetdagboek/adminComments`, formData.id, newObject);
      setCommand(null);
      Swal.fire("Gegevens zijn gewijzigd", "", "success");
      setRefresh(true);
    } catch (error) {
      console.error("Error updating data:", error);
      Swal.fire("Er is een fout opgetreden bij het wijzigen", "", "error");
    }

    setOpen(false);
  };

  const EditTekst = async (item, cmd) => {
    setFormData((prev) => ({
      ...prev,
      id: item?.eetdagboek_id || "",
      user_id: item?.eetdagboek_user_id || "",
      datum: item?.eetdagboek_datum || new Date(),
      dag: item?.eetdagboek_dag || "",
      ochtend: item?.eetdagboek_ochtend || "",
      voormiddag: item?.eetdagboek_voormiddag || "",
      middag: item?.eetdagboek_middag || "",
      namiddag: item?.eetdagboek_namiddag || "",
      avond: item?.eetdagboek_avond || "",
      smorgens: item?.eetdagboek_smorgens || "",
      smiddags: item?.eetdagboek_smiddags || "",
      savonds: item?.eetdagboek_savonds || "",
      type_note: item?.eetdagboek_type_note || 1,
      title: item?.eetdagboek_title || "",
      admin: item?.eetdagboek_admin || commentaaradmin.admin,
      admin_id: item?.eetdagboek_admin_id || commentaaradmin.admin_id,
      score: item?.eetdagboek_score || 0,
      opmerking: item?.eetdagboek_opmerking || "",
      url: item?.eetdagboek_url || "",
    }));
  };

  return (
    <div className="flex min-h-0 flex-1 flex-col bg-wa-app text-wa-text lg:h-[calc(100dvh-4rem)] lg:flex-row">
      <aside className="w-full flex-shrink-0 border-b border-wa-border bg-wa-panel px-3 py-4 sm:px-4 lg:h-full lg:max-h-full lg:w-[min(100%,400px)] lg:border-b-0 lg:border-r lg:overflow-y-auto xl:w-[38%] 2xl:w-1/4">
        <div className="mt-1">
          {patienten.length > 0 && (
            <SelectPatienten variant="wa" selected={selected} setSelected={setSelected} />
          )}
        </div>
        <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
          <label className="block sm:col-span-1">
            <span className="mb-1 block text-xs font-medium text-wa-muted">Van</span>
            <input
              type="date"
              name="startdate"
              id="startdate"
              className="block w-full rounded-lg border border-wa-border bg-wa-hover px-2 py-2 text-sm text-wa-text focus:border-wa-accent focus:outline-none focus:ring-1 focus:ring-wa-accent"
              value={moment(dates.startdate).format("YYYY-MM-DD")}
              onChange={(e) => setdates({ ...dates, startdate: e.target.value })}
            />
          </label>
          <label className="block sm:col-span-1">
            <span className="mb-1 block text-xs font-medium text-wa-muted">Tot</span>
            <input
              type="date"
              name="enddate"
              id="enddate"
              className="block w-full rounded-lg border border-wa-border bg-wa-hover px-2 py-2 text-sm text-wa-text focus:border-wa-accent focus:outline-none focus:ring-1 focus:ring-wa-accent"
              value={moment(dates.enddate).format("YYYY-MM-DD")}
              onChange={(e) => setdates({ ...dates, enddate: e.target.value })}
            />
          </label>
        </div>

        <div className="mt-4 min-h-0 py-1">
          {dagboeken.length > 0 ? (
            <DagBoekList editTekst={EditTekst} showText={EditTekst} dagboeken={dagboeken} />
          ) : (
            <p className="rounded-lg border border-dashed border-wa-border bg-wa-panel2/50 px-3 py-6 text-center text-sm text-wa-muted">
              Geen gegevens gevonden voor deze patiënt in dit datumbereik.
            </p>
          )}
        </div>
      </aside>
      <main className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-wa-app lg:border-l lg:border-wa-border">
        {formData?.title && (
          <div className="grid justify-items-stretch">
            <button
              type="button"
              onClick={() => setOpen(true)}
              className="mx-4 mt-2 inline-flex items-center justify-center gap-2 self-end rounded-lg border border-wa-border bg-wa-panel2 px-4 py-2.5 text-sm font-semibold text-wa-text shadow-sm transition-colors hover:border-wa-accent/50 hover:bg-wa-hover sm:mx-8"
            >
              Opmerking plaatsen
              <DocumentIcon className="-mr-0.5 h-5 w-5 text-wa-accent" aria-hidden="true" />
            </button>
          </div>
        )}
        <div className="xl:pl-4">
          <div className="px-3 py-4 sm:px-6 lg:px-8 lg:py-4">
            <div className="col-span-full">
              <div className="flex flex-col gap-3 gap-x-4 sm:flex-row sm:items-start">
                <div
                  dangerouslySetInnerHTML={{ __html: sanitizeHtml(formData?.title) }}
                  className="mt-2 space-y-2 text-lg font-medium text-wa-text sm:text-xl"
                />
                {formData?.url && (
                  <a
                    href={formData?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="cursor-pointer rounded-lg border border-wa-border bg-wa-panel2 p-3 transition-colors hover:border-wa-accent/40 hover:bg-wa-hover">
                      <span className="flex cursor-pointer items-center gap-2">
                        <PaperClipIcon className="h-6 w-6 text-wa-accent" />
                        <span className="block text-sm font-medium leading-6 text-wa-text">
                          Een Afbeelding van een maaltijd gelinkt
                        </span>
                      </span>
                    </div>
                  </a>
                )}
              </div>
            </div>
            <TypeNote admin={showEdit} Eetdagboek={formData} />
          </div>
        </div>
      </main>
      {formData && (
        <RPDrawerComment
          onClick={Opslaan}
          item={formData}
          admin={formData}
          setUpdateAdmin={setFormData}
          setOpen={setOpen}
          open={open}
        />
      )}
    </div>
  );
};

export default EetdagboekAdmin;
